export class MapState {
  public user: {
    lat: number,
    lon: number,
    address: string,
  }
  public patient: {
    lat: number,
    lon: number,
    address: string,
  }
  constructor() {
    this.user = {
      lat: 0,
      lon: 0,
      address: '',
    }
    this.patient = {
      lat: 0,
      lon: 0,
      address: '',
    }
  }
}

export interface ILocation {
    lat: number,
    lon: number,
    address: string,
}


export default MapState
